import * as React from 'react';
import Slider from '@mui/material/Slider';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

interface HappinessScoreProps {
	handleScoreChange: (newValue: number) => void;
	value: number | undefined;
	defaultValue: number;
}

export const happinessScoreMarks = [
	{ value: 0, label: '😔' },
	{ value: 1, label: '😣' },
	{ value: 2, label: '😕' },
	{ value: 3, label: '🙂' },
	{ value: 4, label: '😊' },
	{ value: 5, label: '😍' }
];

function HappinessScore(props: HappinessScoreProps) {
	const { handleScoreChange, value, defaultValue } = props;
	const emojis = ['😔', '😕', '😐', '🙂', '😀', '😁'];

	const handleOnChange = (event, newValue) => {
		handleScoreChange(newValue);
	};

	return (
		<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginRight: '10px', marginTop: '5px' }}>
			<Typography id='input-slider' gutterBottom variant='body2'>
				✨ Rate Your Day
			</Typography>
			<Box className={'happinessScoreSlider'}>
				<Slider
					aria-label='Happiness Score'
					getAriaValueText={(value) => `${value}`}
					valueLabelFormat={(value) => emojis[value]}
					step={1}
					marks={happinessScoreMarks}
					min={0}
					max={5}
					value={value !== undefined ? value : defaultValue}
					onChange={handleOnChange}
					valueLabelDisplay='auto'
				/>
			</Box>
		</Box>
	);
}

export default React.memo(HappinessScore);
